// extracted by mini-css-extract-plugin
module.exports = {"root":"View_root__21-cm","separator":"View_separator__2OTy8","tabs":"View_tabs__3Veeb","tab":"View_tab__3jBg8","activeTab":"View_activeTab__3a80k","count":"View_count__2tUxI"};